import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5080d386"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home",
  "data-bs-theme": "light"
}
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "All Jobs", -1))
const _hoisted_4 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_5 = {
  key: 1,
  class: "jobtablecontainer"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import JobList from '@/components/JobList.vue';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { useJobStore } from '@/stores/Jobs';
import { storeToRefs } from 'pinia';
import { watch, computed, onMounted, watchEffect } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'JobListView',
  setup(__props) {

const userEmployeeStore = useEmployeeStore();
const jobStore = useJobStore();
const { all_jobs, isLoadingJobs } = storeToRefs(jobStore);
const currentUser = computed(() => userEmployeeStore.currentUser);

const greeting = computed(() => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good Morning';
  if (hour < 18) return 'Good Afternoon';
  return 'Good Evening';
});

onMounted(() => {
  // console.log("Current user at mounted:", userEmployeeStore.currentUser);
  watchEffect(() => {
    // console.log("Current user in watchEffect:", userEmployeeStore.currentUser);
    if (userEmployeeStore.currentUser?.user.is_superuser || userEmployeeStore.currentUser?.user.is_staff) {
      console.log("Admin confirmed, fetching jobs.");
      jobStore.getAllJobs();
    }
  });
});


watch(all_jobs, (newJobs) => {
  if (newJobs) {
    // You can perform additional actions here if needed,
    // such as logging or handling the data differently.
  }
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(greeting.value) + ", " + _toDisplayString(currentUser.value?.user.full_name), 1),
      _hoisted_3
    ]),
    (_unref(isLoadingJobs))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_unref(userEmployeeStore).currentUser?.user.is_superuser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(JobList, {
                  jobs: _unref(all_jobs),
                  "visible-columns": ['id', 'name', 'description', 'task_count', 'status', 'total_active_duration', 'total_cost', 'assigned', 'created_by', 'actions']
                }, null, 8, ["jobs"])
              ]))
            : _createCommentVNode("", true),
          (_unref(userEmployeeStore).currentUser?.user.is_staff && !_unref(userEmployeeStore).currentUser?.user.is_superuser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(JobList, {
                  jobs: _unref(all_jobs),
                  "visible-columns": ['id', 'name', 'description', 'task_count', 'status', 'total_active_duration', 'assigned', 'created_by', 'actions']
                }, null, 8, ["jobs"])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})